<template>
  <div>
    <b-card-text>
      対象に異常状態を付与します。
    </b-card-text>
    <b-card title="対象">
      <b-form-group id="target" label="対象"
        label-cols="3">
        <b-form-select v-model="innerValue.arguments.target" 
          :options="[
            { value:{ '@arg':'target' }, text:'選択対象' },
            { value:{ '@arg':'player' }, text:'自己' }
          ]" />
      </b-form-group>
      <b-form-group id="target2" label="サブ対象"
        description="一部の効果の対象をサブ対象にできます。"
        label-cols="3">
        <b-form-select v-model="innerValue.arguments.target2" 
          :options="[
            { value:{ '@arg':'target' }, text:'選択対象' },
            { value:{ '@arg':'player' }, text:'自己' }
          ]" />
      </b-form-group>
    </b-card>
    <b-form-group id="buff" label="異常状態"
      label-cols="3">
      <b-form-select v-model="innerValue.arguments.buff"
        :options="buffList"
        />
    </b-form-group>
    <b-form-group id="status" label="補正(%)"
      description="使用者のステータスがバフのLvに影響する度合です。"
      label-cols="3">
      <b-container>
        <b-row v-for="(k,j) in chunk4fixStatus" :key="'f'+j">
          <b-col cols="6" v-for="l in k" :key="'fs'+l">
            <b-input-group :prepend="l">
              <b-form-input type="number" v-model="innerValue.arguments[l+'Ratio']" 
                number :step="0.1"/>
            </b-input-group>
          </b-col>
        </b-row>
      </b-container>
    </b-form-group>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
import _ from 'lodash'
const fixStatus = ['STR','INT','VIT','MND','DEX','AGI']
const newCode = ()=>{
  return {
    player: { '@arg':'player' },
    target: { '@arg':'target' },
    target2: { '@arg':'target' },
    dice: { '@arg':'dice' },

    buff: null,
    STRRatio:0.0, INTRatio:0.0,
    VITRatio:0.0, MNDRatio:0.0, 
    DEXRatio:0.0, AGIRatio:0.0
  }    
}
export default {
  props: {
    value: Object,
    info: Object
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  computed: {
    chunk4fixStatus () { return _.chunk(fixStatus,2 ) },
    buffList () {
      let list = []
      this.info.card.forEach((v)=>{
        let e = _.find(v, { '@method':'info', args:{type:'buff'} })
        if(e){
          let i = _.find(v, { '@method':'init' })
          list.push({
            value: i.args.key,
            text: e.args.name,
          })
        }
      })
      return list
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  },
  newCode
}
</script>

<style lang="scss" scoped>

</style>
